import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Badge,
} from "reactstrap";
import moment from "moment";

const DetailsModal = ({ isOpen, toggle, rowData }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {rowData?.type === 'invitation' ? 'Invitation Details' : 'Link Details'}
      </ModalHeader>
      <ModalBody>
        {rowData && (
          <div className="row">
            <div className="col-md-6">
              <h6 className="text-muted">Basic Information</h6>
              <table className="table table-sm">
                <tbody>
                  <tr>
                    <td><strong>Type:</strong></td>
                    <td>
                      <Badge color={rowData.type === 'link' ? 'success' : 'info'}>
                        {rowData.type === 'link' ? 'LINK' : 'INVITATION'}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>User Email:</strong></td>
                    <td>{rowData.user_email}</td>
                  </tr>
                  <tr>
                    <td><strong>Site:</strong></td>
                    <td>{rowData.site_name} (ID: {rowData.site_id})</td>
                  </tr>
                  <tr>
                    <td><strong>Space:</strong></td>
                    <td>{rowData.space_name} (ID: {rowData.space_id})</td>
                  </tr>
                  <tr>
                    <td><strong>Status:</strong></td>
                    <td>
                      {rowData.type === 'link' ? (
                        <Badge color="success">ACTIVE</Badge>
                      ) : (
                        <Badge color={
                          rowData.status === 'PENDING' ? 'info' :
                          rowData.status === 'ACCEPTED' ? 'success' :
                          rowData.status === 'DECLINED' ? 'danger' :
                          rowData.status === 'CANCELLED' ? 'secondary' : 'warning'
                        }>
                          {rowData.status}
                        </Badge>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            {rowData.type === 'invitation' && (
              <div className="col-md-6">
                <h6 className="text-muted">Invitation Details</h6>
                <table className="table table-sm">
                  <tbody>
                    <tr>
                      <td><strong>Invited At:</strong></td>
                      <td>
                        {rowData.invited_at ? 
                          moment(rowData.invited_at).format('MMM DD, YYYY HH:mm') : 
                          '-'
                        }
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Invited By:</strong></td>
                      <td>{rowData.invited_by || '-'}</td>
                    </tr>
                    
                    <tr>
                      <td><strong>Accepted At:</strong></td>
                      <td>{rowData.accepted_at ? 
                        moment(rowData.accepted_at).format('MMM DD, YYYY HH:mm') : 
                        '-'
                      }</td>
                    </tr>
                    <tr>
                      <td><strong>Declined At:</strong></td>
                      <td>{rowData.declined_at ? 
                        moment(rowData.declined_at).format('MMM DD, YYYY HH:mm') : 
                        '-'
                      }</td>
                    </tr>
                    <tr>
                      <td><strong>Cancelled At:</strong></td>
                      <td>{rowData.cancelled_at ? 
                        moment(rowData.cancelled_at).format('MMM DD, YYYY HH:mm') : 
                        '-'
                      }</td>
                    </tr>
                    <tr>
                      <td><strong>Status By:</strong></td>
                      <td>{rowData.cancelled_by || '-'}</td>
                    </tr>
                    <tr>
                      <td><strong>Expires At:</strong></td>
                      <td>
                        {rowData.expires_at ? 
                          moment(rowData.expires_at).format('MMM DD, YYYY HH:mm') : 
                          '-'
                        }
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Invitation ID:</strong></td>
                      <td>{rowData.invite_id}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DetailsModal;
